// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__w4oXt","divider":"Footer_divider__5fKss","note":"Footer_note__ffMwv"};